import getTitle from './getTitle';
export default getTitle;
